import dayjs from 'dayjs';
import { useCallback } from 'react';
import useSaveForm from '@app/common/form/useSaveForm';
import { healthCheckOrderDetailsUrl } from '@app/definition/API';
import useFetchOrders from '../ordersTable/useFetchOrders';
import { FormData, OrderDetailsI } from './types';

export const getDateDiffInYears = (
  currentValues: FormData,
  orderDetails: OrderDetailsI
): number => {
  const birthdate = buildBirthdate(
    currentValues.birthdateDay,
    currentValues.birthdateMonth,
    currentValues.birthdateYear
  );
  const difference = dayjs
    .duration(dayjs(orderDetails.bookedDate).diff(dayjs(birthdate)))
    .asYears();
  return difference;
};

export const buildBirthdate = (
  day: string,
  month: string,
  year: string
): string => {
  const rawDate = `${day} ${month} ${year}`;
  const date = dayjs(rawDate, 'D MMMM YYYY');
  const formatDate = date.format('YYYY-MM-DD');
  return formatDate;
};

const getPutData = (
  data: FormData,
  orderDetails: OrderDetailsI
): OrderDetailsI => {
  const birthdate = buildBirthdate(
    data.birthdateDay,
    data.birthdateMonth,
    data.birthdateYear
  );

  return {
    id: orderDetails.id,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.contactEmail,
    status: orderDetails.status,
    updatedAt: Date.now(),
    testType: data.testType,
    testCategory: data.testCategory,
    passportNumber: data.documentNumber,
    birthdate,
    bookedDate: orderDetails.bookedDate,
    sampleTakenAt: orderDetails.sampleTakenAt,
    reportedAt: orderDetails.reportedAt,
    timerEnd: orderDetails.timerEnd,
    result: orderDetails.result,
    referenceCode: data.referenceCode,
    barcodeNumber: data.barcodeNumber,
    isResendCertificate: orderDetails.isResendCertificate,
    isCertificateGenerated: orderDetails.isCertificateGenerated,
  };
};

const useSaveOrder = (
  orderDetails: OrderDetailsI
): {
  saveOrder: (data: FormData) => Promise<void>;
  loading: boolean;
  isSaved: boolean;
  error: string;
} => {
  const loadOrders = useFetchOrders(false);
  const { loading, error, save, isSaved } = useSaveForm<OrderDetailsI>();

  const saveOrder = useCallback(
    async (data: FormData) => {
      const url = healthCheckOrderDetailsUrl.replace(
        '%id%',
        String(orderDetails.id)
      );

      const putData = getPutData(data, orderDetails);

      await save(url, putData, 'put');

      loadOrders();
    },
    [orderDetails, save, loadOrders]
  );

  return {
    loading,
    error,
    saveOrder,
    isSaved,
  };
};

export default useSaveOrder;
